import React from "react";
import packageJson from '../package.json';
import axios from 'axios';


export default class ignition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ready: false
    };
  }

  postData = async () => {
    console.log("post-data");
    try{
      setTimeout(()=>{
        this.setState({ready: true})
        this.scroll();
      }, 3500);
      // POST DATA
      const response = await axios.post(
        packageJson.URL + '/api/launchconfigurator/',
        {
          user: {...this.props.userData},
          form: {...this.props.formData},
          flight: {...this.props.flightData.flight},
          addons: {...this.props.addOnsData.addOns}
        }
      );
      console.log(response, 2);
    }catch(error) {
      return [];
    }
  }

  componentDidMount() {
    this.postData();
    this.scroll()
  }

  scroll() {
    setTimeout(() => {
      let top = document.getElementById("ignition").getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: top - 60,
        left: 0,
        behavior: 'smooth'
      });
    }, 100);
  }



  render() {
    return (
      <>
        {(!this.state.ready)?
          (
            <div class="p-5 mb-4 bg-light rounded-3">
              <div class="container-fluid">
                <div class="text-center">
                  <div class="spinner-border text-primary mx-auto" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
          )
          :
          (
            <div class="p-5 mb-4 bg-light rounded-3">
              <div class="container-fluid py-5">
                <h1 class="display-5 fw-bold">Thank You!</h1>
                <p class="col-md-8 fs-4">We have just sent a summary of your search to your inbox and we’ll be in touch with you shortly.<br />Get ready to fly!</p>
                <a href="/" class="btn btn-primary btn-lg" type="button">Back To Site</a>
              </div>
            </div>
          )
        }
      </>
    );
  }
}
